import { InformationCircleIcon } from "@heroicons/react/24/solid";
import Avatar from "../Utility/Avatar";
import {
  ButtonSize,
  SecondaryCTAButton,
} from "../quickRound/CTAButtonComponents";
import {
  getShareAuthStore,
  useShareAuthStore,
} from "../../store/useShareAuthStore";
import {
  clearSharedCredentials,
  redirectToSharedHissa,
} from "../../components/utils";
import { queryClient } from "../../queries";

function Navbar({
  companyName,
  cin,
  showNavbar = false,
}: {
  companyName: string;
  cin: string;
  showNavbar?: boolean;
}) {
  const { setShareAuth, shareId, shareUserMail, shareResourceType } =
    useShareAuthStore();
  return (
    <div>
      <div className="sticky top-0 z-40 justify-between bg-secondary flex h-16 shrink-0 items-center gap-x-4 shadow-sm border-gray-200 sm:gap-x-6 px-4 sm:px-6 lg:px-8">
        <div className="">
          <img
            className="h-6 w-auto"
            src={"https://equion-dev.s3.us-west-2.amazonaws.com/hissa-logo.png"}
            alt="hissa_logo"
          />
        </div>
        <div className="text-white text-center mx-auto w-full">
          <p className="text-lg font-bold text-center">{companyName}</p>
          <p className="text-xxs1 text-gray-300 font-normal py-0 my-0 leading-3">{`${shareResourceType} PAGE`}</p>
        </div>
          <div className="justify-end flex items-center gap-x-4 lg:gap-x-6 ">
            <div className="hidden"></div>
            <div
              className="hidden lg:block lg:h-6 lg:w-px lg:bg-white"
              data-aria-hidden="true"
            />
            {/* <SecondaryCTAButton
              buttonSize={ButtonSize.SMALL}
              onClick={() => {
                sessionStorage.clear();
                queryClient.clear();
                getShareAuthStore().clear();
                redirectToSharedHissa(shareId ?? "");
              }}
            >
              Log Out
            </SecondaryCTAButton> */}
            <Avatar name={shareUserMail ?? "U"} isDark={true} />
          </div>
      </div>
    </div>
  );
}

export default Navbar;
